import styled from 'styled-components';

// T2-6042: Tabs are an equal-width segmented control in a single rounded
// container. Active tab is filled cobalt; inactive is transparent. Width is
// 100% so the strip matches the surrounding header / button / job-card
// width (driven by the page container's natural width).
export const TabsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: stretch;
  margin: 0 0 0.75rem;
  padding: 4px;
  gap: 4px;
  flex-wrap: nowrap;
  background: #F3F4F6;
  border-radius: 12px;
  box-sizing: border-box;
`

export const TabComponent = styled.div<{$isActive: boolean, $isLast?: boolean}>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.4rem;
  padding: 0.625rem 0.75rem;
  flex: 1 1 0%;
  min-width: 0;
  box-sizing: border-box;
  background-color: ${({$isActive}) => $isActive ? 'var(--primary-blue, #0B4598)' : 'transparent'};
  color: ${({$isActive}) => $isActive ? '#fff' : 'var(--primary-blue, #0B4598)'};
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: ${({$isActive}) => $isActive ? '0 1px 3px rgba(11, 69, 152, 0.25)' : 'none'};

  svg {
    width: 18px;
    height: 18px;
  }

  &:hover:not(:active) {
    background-color: ${({$isActive}) => $isActive ? 'var(--primary-blue, #0B4598)' : 'rgba(11,69,152,0.06)'};
  }

  @media(min-width: 768px) {
    font-size: 15px;
    padding: 0.75rem 1rem;
  }
`